import React, { useState, useEffect } from 'react';
import { Carousel } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const BannerSection = styled.div`
  margin-top: 64px;
  background: #fff;
  
  .ant-carousel {
    .slick-slide {
      height: 500px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #f5f5f5;
      }
    }
    
    .slick-dots {
      bottom: 16px;
      
      li button {
        background: #fff;
        opacity: 0.7;
      }
      
      li.slick-active button {
        background: #D4303B;
        opacity: 1;
      }
    }
  }

  @media (max-width: 576px) {
    margin-top: 56px;
    
    .ant-carousel .slick-slide {
      height: 300px;
    }
  }
`;

const Banner = ({ images = [] }) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  // 检测设备类型
  useEffect(() => {
    const checkDevice = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
    };

    // 初始检查
    checkDevice();

    // 监听窗口大小变化
    window.addEventListener('resize', checkDevice);
    
    // 组件卸载时移除监听器
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  if (images.length === 0) {
    return null;
  }

  // 根据设备类型选择合适的图片URL
  const getBannerImage = (item) => {
    // 如果是移动设备且有移动端图片，则使用移动端图片
    if (isMobile && item.mobileBanner) {
      return item.mobileBanner;
    }
    // 否则使用默认图片（Web端）
    return item.image;
  };

  return (
    <BannerSection>
      <Carousel
        autoplay
        effect="fade"
        autoplaySpeed={3000}
        dots={true}
        infinite={true}
      >
        {images.map((item, index) => (
          <div key={index}>
            <img 
              src={getBannerImage(item)} 
              alt={t('home.banners.imageAlt', { index: index + 1 })} 
            />
          </div>
        ))}
      </Carousel>
    </BannerSection>
  );
};

export default Banner; 